import GuarantorScreen from './GuarantorScreen';

export default GuarantorScreen;
